import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-open-menu",
  "use": "icon-open-menu-usage",
  "viewBox": "0 0 15.119 14.88",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"open-menu\" viewBox=\"0 0 15.119 14.88\" id=\"icon-open-menu\"><g data-name=\"Group 865\"><path d=\"M14.498 13.377H.698a.766.766 0 0 0 0 1.5h13.8a.766.766 0 0 0 0-1.5Z\" data-name=\"Path 327\" /><path d=\"M.621 1.504h13.8a.766.766 0 0 0 0-1.5H.621a.766.766 0 0 0 0 1.5Z\" data-name=\"Path 328\" /><path d=\"M.621 8.229h13.8a.766.766 0 0 0 0-1.5H.621a.766.766 0 0 0 0 1.5Z\" data-name=\"Path 329\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol